import { BrowserModule } from '@angular/platform-browser';
import
{
    APP_INITIALIZER,
    ErrorHandler,
    NgModule,
    provideZoneChangeDetection
} from '@angular/core';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from
    '@angular/common/http';

import { AppComponent } from './app.component';
import { PreloadAllModules, Router, RouterModule } from
    '@angular/router';
import * as Sentry from '@sentry/angular';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { MatButtonModule} from '@angular/material/button';
import { MatInputModule} from '@angular/material/input';
import { MatCardModule} from '@angular/material/card';
import { MatMenuModule} from '@angular/material/menu';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatIconModule} from '@angular/material/icon';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatListModule} from '@angular/material/list';
import { MatGridListModule} from '@angular/material/grid-list';
import { MatTableModule} from '@angular/material/table';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from
    '@angular/material/autocomplete';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

import { ScrollingModule } from '@angular/cdk/scrolling';

import {fakeBackendProvider} from './helper/fackeBackEnd';

//import { PublicLayoutModule } from './layout/publicLayout.module';
import { PublicModule } from './public/public.module';
//import { SecureLayoutModule } from './layout/secureLayout.module';
import { SecureModule } from '@app/secure/secure.module';
import { ShareModule } from '@app/secure/share/share.module';
import { LoadingOverlayComponent } from
    '@app/shared/loadingOverlay/loadingOverlay.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

//import { BasicAuthInterceptor } from './helper/auth.interceptor';
//import { ErrorInterceptor } from './helper/error.interceptor';

@NgModule
({
    declarations:
    [
        AppComponent
    ],
    bootstrap:
    [
        AppComponent
    ],
    imports:
    [
        BrowserModule,
        RouterModule.forRoot([]),
        //    PublicLayoutModule,
        BrowserAnimationsModule,
        FormsModule,
        MatButtonModule,
        MatInputModule,
        MatMenuModule,
        MatCardModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatGridListModule,
        MatTableModule,
        MatTooltipModule,
        MatDialogModule,
        ScrollingModule,
        PublicModule,
        SecureModule,
        ShareModule,
        LoadingOverlayComponent,
        EditorModule], providers: [
        //      { provide: HTTP_INTERCEPTORS,
        //        useClass: BasicAuthInterceptor, multi: true },
        //      { provide: HTTP_INTERCEPTORS,
        //        useClass: ErrorInterceptor, multi: true },
        //      {provide: LocationStrategy, useClass: HashLocationStrategy},
        // provider used to create fake backend
        fakeBackendProvider,
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
        {
            provide: MAT_SELECT_CONFIG,
            useValue: { hideSingleSelectionIndicator: true }
        },
        {
            provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
            useValue: { hideSingleSelectionIndicator: true }
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler()
        },
        {
            provide: Sentry.TraceService,
            deps: [Router]
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () =>
            {
                return undefined;
            },
            deps: [Sentry.TraceService],
            multi: true
        },
        // Components mutate plain fields in subscribe callbacks and rely on
        // zone-triggered change detection (Angular 21 defaults to zoneless).
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideAnimationsAsync(),
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
})
export class AppModule { }
